import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "dd-card-table_wrapper" }
const _hoisted_2 = { class: "table-item-ul clearfix" }
const _hoisted_3 = { class: "table-item_text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("ul", null, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
        return (_openBlock(), _createBlock("li", {
          class: "card-table-ul",
          key: item.seq
        }, [
          _withDirectives(_createVNode("h5", { class: "table-seq" }, _toDisplayString(item.seq), 513), [
            [_vShow, item.seq]
          ]),
          _createVNode("ul", _hoisted_2, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.contents, (detail, index) => {
              return (_openBlock(), _createBlock("li", {
                class: "table-item-li_wrapper",
                key: index
              }, [
                _createVNode("span", _hoisted_3, _toDisplayString(detail.columnName) + ":  " + _toDisplayString(detail.columnContent), 1)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}